import React from "react";
import {
  FileText,
  Stethoscope,
  Heartbeat,
  Thermometer,
  Brain,
  Users,
  Syringe,
  FirstAidKit,
  Pill,
} from "@phosphor-icons/react";

interface TransparentModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  handleSelect: (option: string) => void;
}

const options = [
  {
    key: "history_present_illness",
    text: "History of Present Illness",
    icon: <FileText size={32} className="text-gray-100" />,
  },
  {
    key: "review_of_systems",
    text: "Review of Systems",
    icon: <Thermometer size={32} className="text-gray-100" />,
  },
  {
    key: "physical_exam",
    text: "Physical Exam",
    icon: <Stethoscope size={32} className="text-gray-100" />,
  },
  {
    key: "differential_diagnosis",
    text: "Differential Diagnosis",
    icon: <Heartbeat size={32} className="text-gray-100" />,
  },
  {
    key: "medical_decision_making",
    text: "Medical Decision Making",
    icon: <Brain size={32} className="text-gray-100" />,
  },
  {
    key: "consults",
    text: "Consults",
    icon: <Users size={32} className="text-gray-100" />,
  },
  {
    key: "procedures",
    text: "Procedures",
    icon: <Syringe size={32} className="text-gray-100" />,
  },
  {
    key: "critical_care_note",
    text: "Critical Care Note",
    icon: <FirstAidKit size={32} className="text-gray-100" />,
  },
  {
    key: "disposition",
    text: "Disposition",
    icon: <Pill size={32} className="text-gray-100" />,
  },
];

const TransparentModal: React.FC<TransparentModalProps> = ({
  open,
  setOpen,
  handleSelect,
}) => {
  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center 
        bg-black bg-opacity-80 dark:bg-opacity-50 backdrop-blur-sm 
        transition-opacity duration-300 
        ${open ? "opacity-100 visible" : "opacity-0 invisible"}`}
      onClick={() => setOpen(false)}
    >
      <div
        className={`md:w-[70%] lg:w-[90%] xl:w-3/4 2xl:w-2/3 flex flex-wrap justify-center sm:gap-12 transform transition-all duration-300 
        ${open ? "scale-100 opacity-100" : "scale-90 opacity-0"}`}
      >
        {options.map((option) => (
          <div
            key={option.key}
            className="my-5 sm:my-1 cursor-pointer flex flex-col items-center px-5 hover:opacity-50 sm:w-[150px] w-[120px]"
            onClick={() => {
              handleSelect(option.key);
              setOpen(false);
            }}
          >
            <div className="rounded-full border-2 border-gray-300 dark:border-gray-500 p-4">
              {option.icon}
            </div>
            <div className="text-sm sm:text-base mt-2 text-white text-wrap text-center">
              {option.text}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TransparentModal;
